"use strict";

var isBisEnabled = $(".attributes").data("isbisenabled");

module.exports = {
    backinstockEvents: function () {
        if (isBisEnabled) {
            var bisSFRA = require("@bis/backinstock/bisSFRA");

            $(document).ready(function () {
                if ($("#bis-button-data").data("is-sfra")) {
                    bisSFRA.initializeEvents();
                }
                $("input").on("click", function () {
                    var url = $("#bisWishlist").data("url");

                    if (!url) {
                        return;
                    }

                    if ($("#bisWishlist:checkbox:checked").length > 0) {
                        $.ajax({
                            url: url,
                            type: "post",
                            dataType: "json",
                            data: {
                                isChecked: true
                            }
                        });
                    } else {
                        $.ajax({
                            url: url,
                            type: "post",
                            dataType: "json",
                            data: {
                                isChecked: false
                            }
                        });
                    }
                });
            });
        }
    }
};
